/**
 * IncidentsSection — масштаб найденного и то, как за ним поспевает разбор.
 *
 * Сам график живёт в `IncidentsFlow` (`ExecutiveReportChart`): накопительный
 * поток, очередь по дням и три итога, которые из этого потока считаются.
 * Здесь остаётся то, что к графику не относится, — уход в продукт за
 * разбором каждой ошибки.
 *
 * Ряд из снимка приходит накопительным, а график принимает подневные
 * приросты, поэтому между ними стоит `toIncidentsFlowInput`. Перевод
 * обратим: суммы приростов сходятся с `totalFound` и `totalFixed`.
 *
 * @format
 */

import {useMemo} from 'react';

import {Stack} from 'ui/components/layout/Stack';

import {IncidentsFlow} from '../../ExecutiveReportChart/IncidentsFlow';
import {toIncidentsFlowInput} from '../incidentsFlowInput';
import type {Incidents} from '../types';

export interface IncidentsSectionProps {
  data: Incidents;
}

export function IncidentsSection({data}: IncidentsSectionProps) {
  // Recharts перемонтирует детей при новой ссылке в пропах — пересчитываем
  // ряд на данные, а не на каждый рендер страницы.
  const {days, openingBacklog} = useMemo(() => toIncidentsFlowInput(data), [data]);

  return (
    <Stack gap='l'>
      <IncidentsFlow days={days} openingBacklog={openingBacklog} />
    </Stack>
  );
}
